// App.js
import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import About from "./pages/About";
import Services from "./pages/Services";
import ServiceDetail from "./pages/ServiceDetail";
import BlogDetail from "./pages/BlogDetail";
import Projects from "./pages/Projects";
import Blog from "./pages/Blog";
import Contact from "./pages/Contact";
import Enquire from "./pages/Enquire";
import Terms_And_Conditions from "./pages/Terms_And_Conditions";
import Cookie_Policy from "./pages/Cookie_Policy";
import Gdpr_Policy from "./pages/Gdpr_Policy";
import Loader from "./components/Loader";
import MusicPopup from "./components/MusicPopup";
import CookieNotice from "./components/CookieNotice";
import "./css/custom.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const ProgressLoader = ({ isLoading }) => {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    if (isLoading) {
      setProgress(0);
      const interval = setInterval(() => {
        setProgress((prev) => {
          if (prev >= 90) return prev;
          return prev + Math.random() * 15;
        });
      }, 100);
      return () => clearInterval(interval);
    } else {
      setProgress(100);
      setTimeout(() => setProgress(0), 500);
    }
  }, [isLoading]);

  if (!isLoading && progress === 0) return null;

  return (
    <div style={{ position: "fixed", top: 0, left: 0, width: "100%", zIndex: 9999 }}>
      <div
        style={{
          height: "3px",
          backgroundColor: "#5a4140",
          width: `${progress}%`,
          transition: "all 0.3s ease-out",
          boxShadow: "0 0 10px rgba(163, 163, 163, 0.5)",
        }}
      />
    </div>
  );
};

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, [pathname]);

  return null;
}
const usePageTransition = () => {
  const [isLoading, setIsLoading] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setIsLoading(true);
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 800);
    return () => clearTimeout(timer);
  }, [location.pathname]);

  return isLoading;
};

function PageWrapper() {
  const location = useLocation();
  const [loading, setLoading] = useState(false);
  const isLoading = usePageTransition();

  useEffect(() => {
    if (location.pathname === "/") {
      setLoading(true);
      const handleLoad = () => setLoading(false);
      window.addEventListener("load", handleLoad);
      return () => window.removeEventListener("load", handleLoad);
    } else {
      setLoading(false);
    }
  }, [location.pathname]);

  return (
    <>
      <ProgressLoader isLoading={isLoading} />
      <ScrollToTop />

      <Header />
      
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/services" element={<Services />} />
        <Route path="/service-detail/:id" element={<ServiceDetail />} />
        <Route path="/projects" element={<Projects />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/enquire" element={<Enquire />} />
        <Route path="/cookie_policy" element={<Cookie_Policy />} />
        <Route path="/gdpr_policy" element={<Gdpr_Policy />} />
        <Route path="/terms_and_conditions" element={<Terms_And_Conditions />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/blog/:slug" element={<BlogDetail />} />
      </Routes>
      <CookieNotice />
      <Footer />

      {loading && location.pathname === "/" && <Loader />}

      {location.pathname === "/" && <MusicPopup />}
    </>
  );
}

function App() {
  return (
    <Router>
      <PageWrapper />
    </Router>
  );
}

export default App;
